const answers = [
  {
    step: 1,
    content: '이건 못 참지. 핸드폰을 본다.',
    effect: [1, 2, 5, 6, 7, 10, 11, 15],
  },
  {
    step: 1,
    content: '하려던 일을 계획대로 시작한다.',
    effect: [3, 4, 8, 9, 12, 13, 14, 16],
  },
  {
    step: 2,
    content: '업무별로 폴더를 만들어 이 파일들(264개)을 정리해 놓으세요.',
    effect: [1, 2, 3, 5, 6, 8, 9, 13],
  },
  {
    step: 2,
    content: 'Z 세대를 겨냥해 신제품 마케팅 아이디어를 내 보세요.',
    effect: [4, 7, 10, 11, 12, 14, 15],
  },
  {
    step: 3,
    content: '어제와 다른 내가 되는 건 언제나 즐거운 일!',
    effect: [4, 5, 6, 9, 14],
  },
  {
    step: 3,
    content: '응, 아니야. 노는 게 제일 좋아.',
    effect: [1, 2, 7, 8, 10, 11, 15],
  },
  {
    step: 4,
    content: '내가 이 구역의 셜록이다. 이미 범인을 추리하고 있다.',
    effect: [7, 11, 14, 15],
  },
  {
    step: 4,
    content: '침착하게 심신의 안정을 찾기 위해 노력한다.',
    effect: [1, 2, 3, 4, 5, 9, 12, 13],
  },
  {
    step: 4,
    content: '일단 손에 잡히는 대로 무기를 확보한다.',
    effect: [7, 10, 16],
  },
  {
    step: 5,
    content:
      '먹는 즐거움은 포기할 수 없다. 필사적으로 다양한 감자 레시피를 개발한다.',
    effect: [1, 2, 5],
  },
  {
    step: 5,
    content:
      '먹는 것도 좋지만 심심한 건 더 싫다. 뭘 하며 보낼지가 더 고민이다.',
    effect: [3, 4, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
  },
  {
    step: 6,
    content: '말만 잘 하면 되는 발표가 제일 쉽다.',
    effect: [2, 6, 8, 10, 11, 14, 16],
  },
  {
    step: 6,
    content: '무난하게 자료 조사를 맡는다.',
    effect: [3, 5, 13],
  },
  {
    step: 6,
    content: '굴림체, 보노보노 못 참아. PPT는 내가 집도한다.',
    effect: [1, 4, 8, 12, 14],
  },
  {
    step: 7,
    content: '웬만하면 바로바로 치운다.',
    effect: [3, 5, 6, 8, 9, 12, 13, 16],
  },
  {
    step: 7,
    content: '내일의 나야 부탁해!',
    effect: [2, 10, 11, 15],
  },
  {
    step: 8,
    content: '휴가는 말 그대로 쉬는 것. 호캉스 or 휴양지 선호.',
    effect: [3, 4, 6, 11, 14, 15],
  },
  {
    step: 8,
    content: '난 자극이 없으면 안 되는 인간. 액티비티 선호.',
    effect: [7, 9, 10, 12, 13],
  },
  {
    step: 8,
    content: '낯선 곳에 왔으면 돌아다니고 먹어야지. 시내 관광 선호.',
    effect: [1, 2, 5, 16],
  },
  {
    step: 9,
    content: '티끌모아 태산이라 했다. 저축한다.',
    effect: [3, 4, 8, 14, 16],
  },
  {
    step: 9,
    content: '고생한 나에게 작은 것이라도 선물한다.',
    effect: [1, 2, 5, 6, 7, 9, 11, 12, 13],
  },
  {
    step: 10,
    content: '안녕히 계세요 여러분! 꿈나라로 도피한다.',
    effect: [1, 2, 6, 7, 15],
  },
  {
    step: 10,
    content: '산책이나 운동으로 몸을 움직인다.',
    effect: [3, 5, 8, 9, 10, 13, 16],
  },
  {
    step: 10,
    content: '영화나 게임 등의 콘텐츠를 즐긴다.',
    effect: [4, 11, 12, 14, 15, 16],
  },
  {
    step: 11,
    content: '노래를 부르거나 듣는다.',
    effect: [4, 6, 8, 10, 13, 16],
  },
  {
    step: 11,
    content: '이런 저런 상념이나 망상에 잠긴다.',
    effect: [1, 3, 9, 11, 12, 15],
  },
  {
    step: 12,
    content: '사실 귀찮았는데 오히려 잘 됐다.',
    effect: [1, 3, 4, 7, 12, 13, 14, 15],
  },
  {
    step: 12,
    content: '이대로 끝낼 순 없다. 다른 친구를 부른다.',
    effect: [2, 5, 7, 10, 16],
  },
  {
    step: 12,
    content: '일단 외출준비한 게 아까우니 셀카를 찍는다.',
    effect: [6, 8, 9],
  },
];

export default answers;
